import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {keys} from "../../Constants"

// import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
//styles
import './PointsTable.css'

class PointsTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            table: []
        };
    }
    componentWillMount() {

    }

    render() {
        const items = this.props.table.map(item => {
            return {
                "id": item.name,
                "name": item.name,
                "nearPoints": item.nearPoints,
                "centerPoints": item.centerPoints,
                "distancePoints": item.distancePoints
            };
        });
        //let empty = "";
        const options = {
            // page: 2,  // which page you want to show as default
            // sizePerPageList: [ {
            //     text: '5', value: 5
            // }, {
            //     text: '10', value: 10
            // }, {
            //     text: 'All', value: products.length
            // } ], // you can change the dropdown list for size per page
            sizePerPage: 15,  // which size per page you want to locate as default
        //    pageStartIndex: 0, // where to start counting the pages
        //    paginationSize: 3,  // the pagination bar size.
            // prePage: 'Prev', // Previous page button text
            // nextPage: 'Next', // Next page button text
            // firstPage: 'First', // First page button text
            // lastPage: 'Last', // Last page button text
            // paginationShowsTotal: this.renderShowsTotal,  // Accept bool or function
            // paginationPosition: 'top'  // default is bottom, top and both is all available
            hideSizePerPage: true //> You can hide the dropdown for sizePerPage
            // alwaysShowAllBtns: true // Always show next and previous button
            // withFirstAndLast: false > Hide the going to First and Last page button
        };

        return (
            <div className="pointTable">
                <BootstrapTable data={items}
                                striped
                                pagination={ false }
                                options={ options }
                                tableHeaderClass='leung-table'
                                tableBodyClass='leung-table'
                                trClassName='leung-table'
                                tableStyle={ { width: '100%', marginBottom: '0', marginLeft: 'auto', marginRight: 'auto', marginTop: '5px'} }
                >
                    <TableHeaderColumn isKey
                                       dataField='id'
                                       hidden>ID</TableHeaderColumn>
                    <TableHeaderColumn thStyle={ {fontSize: '18px'}}
                                       className='leung-table'
                                       width='19%'
                                       dataSort={ false }
                                       dataField={keys.name.value}
                    >Orgán</TableHeaderColumn>
                    <TableHeaderColumn thStyle={ {fontSize: '18px'}}
                                       className='leung-table'
                                       width='25%'
                                       dataSort={ false }
                                       dataField={keys.nearPoints.value}
                    >{keys.nearPoints.label}</TableHeaderColumn>
                    <TableHeaderColumn thStyle={ {fontSize: '18px'}}
                                       className='leung-table'
                                       width='25%'
                                       dataSort={ false }
                                       dataField={keys.centerPoints.value}
                    >{keys.centerPoints.label}</TableHeaderColumn>
                    <TableHeaderColumn thStyle={ {fontSize: '18px'}}
                                       className='leung-table'
                                       width='25%'
                                       dataSort={ false }
                                       dataField={keys.distancePoints.value}
                    >{keys.distancePoints.label}</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }


}

export default PointsTable;